import styled from 'styled-components';

export const MpBadge = styled(`div`)<{ color: 'warning' | 'error' }>`
	position: absolute;
	top: -10px;
	right: -7px;
	width: 6px;
	height: 6px;
	border-radius: 50px;
	background-color: ${props => (props.color === `warning` ? `#FAAD14` : `#F5222D`)};
`;
